import React from 'react';
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { UtenteLogged } from "../../authentication/authenticationSlice";
import { useLocation } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Routes_path } from "../../routerApp";
import { PermissionTypes } from "components/authentication/permissionsGroups";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ElementoMenuControllato from "./ElementoMenuControllato";
import Divider from "@mui/material/Divider";
import HomeIcon from "@mui/icons-material/Home";
import ConstructionIcon from "@mui/icons-material/Construction";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ClearAllIcon from '@mui/icons-material/ClearAll';
import BlockIcon from '@mui/icons-material/Block';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';


const PREFIX = "SideMenu";

const classes = {
	iconSelected: `${PREFIX}-iconSelected`,
};

const styleListItem = { justifyContent: "center" };

interface SideMenuProps {
	open: boolean;
	tooggleDrawer: () => void;
}
const SideMenu = ({ open, tooggleDrawer }: SideMenuProps) => {
	const location = useLocation();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down("md"));
	// const matches = useMediaQuery("min-width:900px)");
	const mobiletooggleDrawer = () => {
		matches && tooggleDrawer();
	};

	const StyledList = styled(List)(() => ({
		[`& .${classes.iconSelected}`]: {
			color: theme.palette.info.main,
		},
	}));
	const utente = useSelector<RootState, UtenteLogged>(
		(state) => state.authentication.utenteLogged
	);

	return (
		<StyledList>
			<ListItem component={Link} to="/" key={"Home"} sx={styleListItem}>
				<ListItemIcon sx={{ minWidth: "auto" }}>
					<HomeIcon
						className={location.pathname == "/" ? classes.iconSelected : ""}
						onClick={mobiletooggleDrawer}
					/>
				</ListItemIcon>
				{open && (
					<ListItemText
						style={{ marginLeft: 12 }}
						primary={"Home"}
						className={location.pathname == "/" ? classes.iconSelected : ""}
						onClick={mobiletooggleDrawer}
					/>
				)}
			</ListItem>

			<ElementoMenuControllato
				path={Routes_path.ODP_SEGUITI}
				label="OdP seguiti"
				gruppiAutorizzati={[
					PermissionTypes.ALL,
					// PermissionTypes.PIANIFICATORI_LETTURA,
				]}
				open={open}
				selected={location.pathname == Routes_path.ODP_SEGUITI}
				tooggleDrawer={tooggleDrawer}
				Icon={ConstructionIcon}
			/>

			<ElementoMenuControllato
				path={Routes_path.OSTACOLI}
				label="Ostacoli"
				gruppiAutorizzati={[
					PermissionTypes.ALL,
				]}
				open={open}
				selected={location.pathname == Routes_path.OSTACOLI}
				tooggleDrawer={tooggleDrawer}
				Icon={BlockIcon}
			/>


			<ElementoMenuControllato
				path={Routes_path.SCHEDULAZIONE}
				label="Schedulazione"
				gruppiAutorizzati={[
					PermissionTypes.ALL,
					// PermissionTypes.PIANIFICATORI_LETTURA,
				]}
				open={open}
				selected={location.pathname == Routes_path.HOME}
				tooggleDrawer={tooggleDrawer}
				Icon={ClearAllIcon}
			/>


			<ElementoMenuControllato
				path={Routes_path.REPARTI}
				label="Reparti"
				gruppiAutorizzati={[
					PermissionTypes.ALL,
				]}
				open={open}
				selected={location.pathname == Routes_path.REPARTI}
				tooggleDrawer={tooggleDrawer}
				Icon={PrecisionManufacturingIcon}
			/>
			{/*<ElementoMenuControllato*/}
			{/*	path={Routes_path.TICKETING}*/}
			{/*	label="Ticketing"*/}
			{/*	gruppiAutorizzati={[*/}
			{/*		PermissionTypes.TICKETING_ASSISTENZA,*/}
			{/*		// PermissionTypes.ALL,*/}
			{/*		// PermissionTypes.PIANIFICATORI_LETTURA,*/}
			{/*	]}*/}
			{/*	open={open}*/}
			{/*	selected={location.pathname == Routes_path.TICKETING}*/}
			{/*	tooggleDrawer={tooggleDrawer}*/}
			{/*	Icon={SupportAgentIcon}*/}
			{/*/>*/}

			<Divider />

			{(utente.is_staff || utente.is_superuser) && (
				<ListItem
					component="a"
					target="_blank"
					rel="noopener"
					href={process.env.API_URL + "/admin"}
					key="Admin_be"
					sx={styleListItem}
				>
					<ListItemIcon style={{ minWidth: "auto" }}>
						<ManageAccountsIcon
							className={
								location.pathname == process.env.API_URL + "/admin"
									? classes.iconSelected
									: ""
							}
							onClick={mobiletooggleDrawer}
						/>
					</ListItemIcon>
					{open && (
						<ListItemText
							style={{ marginLeft: 12, fontStyle: "italic" }}
							primary={"Admin"}
							className={
								location.pathname == process.env.API_URL + "/admin"
									? classes.iconSelected
									: ""
							}
							onClick={mobiletooggleDrawer}
						/>
					)}
				</ListItem>
			)}
		</StyledList>
	);
};

export default SideMenu;
